//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Loading } from "../../shared/components";
import { LoadingContext } from "../../shared/context/LoadingContext";
import { ProdutosContext } from "./context/ProdutosContext";
import { Main } from "./components";
import { loadProductsService } from "./services";



//--------------- EXPORTAÇÃO DA PÁGINA PRODUTOS ---------------//
export default function Produtos() {



  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const { products, setProducts } = useContext(ProdutosContext); // Estado que armazena a lista de Produtos existentes
  const { isLoading, setIsLoading } = useContext(LoadingContext); // Estado que armazena se a tela de carregamento está aparecendo ou não (inicia aparecendo)



  //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
  useEffect(() => {
    handleLoadingProducts();
  }, []);



  //--------------- FUNÇÃO ASSÍNCRONA CARREGAR PRODUTOS ---------------//
  // Responsável por requisitar à API os produtos existentes
  // Armazena no Estado "produtos" a lista de produtos retornadas pela API
  async function handleLoadingProducts() {
    setIsLoading(true);
    const response = await loadProductsService();
    if (response) {
      console.log("🚀 Produtos carregados:", response.data);
      setProducts(response.data);
    }
    setIsLoading(false);
  };



  //--------------- RETORNO CONDICIONAL DA PÁGINA PRODUTOS ---------------//
  return (
    <>
      {isLoading || products === null ? <Loading /> : <Main />}
    </>
  )
}